import React, { memo, Suspense } from 'react';
import { ContactButton } from 'components/contact-button/contact-button';
import { useTimeoutToggle } from 'libs/hooks';
import './app.scss';
import { Helmet } from 'react-helmet';
import HeaderForChannel from 'components/header/header-for-channel';

const MainSection = React.lazy(
  () => import('./containers/main-section/main-section'),
);
const Plans = React.lazy(() => import('./containers/plans/plans'));
const Testimonials = React.lazy(
  () => import('./containers/testimonials/testimonials'),
);
const FrequentQuestions = React.lazy(
  () => import('./containers/frequent-questions/frequent-questions'),
);
const BenefitCards = React.lazy(
  () => import('./containers/benefit-cards/benefit-cards'),
);
const Footer = React.lazy(() => import('components/footer/footer'));

const LandingAutosApp: React.FC = () => {
  const [loadMainSection] = useTimeoutToggle(false, 1000);

  return (
    <React.Fragment>
      <Helmet>
        <title>Cotizar y Comprar Seguro Vehicular - Pacífico</title>
        <meta
          name="description"
          content="Aprovecha en cotizar con planes a tu medida y comprar tu seguro vehicular con precios a tu alcance. Descuentos en gasolina. Te ayudamos con tu compra."
        ></meta>
        <meta
          name="keywords"
          content="seguro vehicular precios, comprar seguro vehicular, cotizar seguro vehicular"
        />
      </Helmet>
      <div className="landing-autos-app" data-testid="landing-autos">
        <HeaderForChannel />
        {loadMainSection && <ContactButton />}
        <MainSection reverseWrapperBanner />
        <div className="container-min-height">
          <Suspense fallback="">
            <Plans />
          </Suspense>
        </div>
        <div className="container-min-height" data-testid="benefits">
          <Suspense fallback="">
            <BenefitCards />
          </Suspense>
        </div>
        <div className="container-min-height" data-testid="testimonials">
          <Suspense fallback="">
            <Testimonials />
          </Suspense>
        </div>
        <div className="container-min-height" data-testid="faq">
          <Suspense fallback="">
            <FrequentQuestions />
          </Suspense>
        </div>
        <div className="container-min-height">
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
};
export default memo(LandingAutosApp);
